<!-- 温控器实时读数+控制 -->
<template>
    <div class='container containerBox'>
        <div class="detail-box equient-detail-box">
            <div class="detail-subtitle">基本信息
                <el-button class="fr" style="margin-right:20px;" @click="refresh" size="mini" type="primary" icon="el-icon-refresh" plain>刷新数据</el-button>
            </div>
            <div class="detail-item">
                <el-row :gutter="5">
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>表计序列号：</span><span>{{modelData['device-serial']}}</span>
                    </el-col>
                    <!-- <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>表计类型：</span><span>{{modelData['devicetype'] === 1 ? '温控器' : "风柜"}}</span>
                    </el-col> -->
                     <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>表计型号：</span><span>{{modelData['device-model']}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>状态：</span><span>{{modelData['status'] === 1 ? '在线' : "离线"}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>在线状态：</span><span>{{modelData['power_on'] === 1 ? '开机' : "关机"}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6" v-if="showspeed">
                        <span>电磁阀：</span><span>{{fmtValueOn(modelData.valve_on)}}</span>
                    </el-col>
                    <el-col v-if="modelData['device-model'] == 'FC109R'" :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>时钟：</span><span>{{`${modelData.time_hour}: ${modelData.time_minute}: ${modelData.time_second}`}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6" v-if="showspeed">
                        <span>风速：</span><span>{{fmtSpeed(modelData.speed)}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                        <span>模式：</span><span>{{fmtMode(modelData.mode)}}</span>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                       <span>设置温度：</span><span>{{modelData.temperature + "°C"}}</span>
                    </el-col>
                    <el-col v-if="modelData['device-model'] != 'FC100CKB'"  :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                       <span>室内温度：</span><span>{{modelData.room_temperature + "°C"}}</span>
                    </el-col>
                    <el-col  :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                       <span>防冻保护：</span><span>{{modelData.antifreezing === 1 ? '开启' : "关闭"}}</span>
                    </el-col>
                    <el-col v-if="modelData['device-model'] == 'FC109R'" :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                       <span>来电运行方式：</span><span>{{fmtOpAtAcback(modelData.op_at_acback)}}</span>
                    </el-col>
					<el-col v-if="modelData['device-model'] == 'FC100CKB'" :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
					   <span>回风温度：</span><span>{{modelData.temp_air + "°C"}}</span>
					</el-col>
					<el-col v-if="modelData['device-model'] == 'FC100CKB'" :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
					   <span>回风感温器补偿：</span><span>{{modelData.setting_calibrationailue + "°C"}}</span>
					</el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6" v-if="showlock">
                       <span>按键锁：</span><span>{{fmtKeyLock(modelData.key_lock)}}</span>
                    </el-col>
					<el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6" v-if="!showspeed">
					   <span>两管制冷热水阀输出开度：</span><span>{{modelData.twopipe_value}}</span>
					</el-col>
					<el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6" v-if="modelData['device-model'] == 'FC890'">
					   <span>外环境传感器温度：</span><span>{{modelData.extsensor_value + "°C"}}</span>
					</el-col>
                </el-row>
            </div>
            <div class="control-box">
                <div class="control-title">
                    <span>控制参数</span>
                </div>
                <el-form :model="form" status-icon :rules="rules" ref="ruleForm2" label-width="90px" class="ruleForm">
                    <el-form-item label="状态" prop="power_on">
                        <el-select v-model="form.powerStatus" clearable placeholder="请选择" >
                            <el-option
                                  v-for="item in options1"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="风速" prop="speed" v-if="showspeed" >
                        <el-select v-model="form.fanSpeed" clearable placeholder="请选择" >
                            <el-option
                                  v-for="item in options2"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="模式" prop="mode">
                        <el-select v-model="form.workMode" clearable placeholder="请选择" >
                            <el-option
                                  v-for="item in options3"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="温度设置" prop="roomTemperatureSp">
                        <el-input v-model="form.roomTemperatureSp" 
                            @blur="handleChangeInput('roomTemperatureSp')" 
                            clearable
                            placeholder="请输入温度"></el-input>
                    </el-form-item>
					<!-- <el-form-item v-if="modelData['device-model'] == 'FC100CKB'" label="回风感温器补偿" prop="roomTemperatureSp">
					    <el-input v-model="form.air_sensor_alibration" 
					        @blur="handleChangeInputair('air_sensor_alibration')" 
					        clearable
					        placeholder="请输入回风感温器补偿"></el-input>
					</el-form-item> -->
                    <el-form-item label="锁定" prop="key_lock" v-if="showlock">
                        <el-select v-model="form.keyBoardlock" clearable placeholder="请选择" >
                            <el-option
                                  v-for="item in options4"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onResult">确认</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import Service from '@/api/Service'
let Timer;
let COUNT = 1;

export default {
    name:  'equipmentcontrol',
    data() {
        return {
            modelData: {},
			showlock:true,
			showspeed:true,
			options1: [{
			          value: 'on',
			          label: '开机'
			        }, {
			          value: 'off',
			          label: '关机'
			        }],
			options2: [{
			          value: 'auto',
			          label: '自动'
			        }, {
			          value: 'high',
			          label: '高风'
			        }, {
			          value: 'medium',
			          label: '中风'
			        }, {
			          value: 'low',
			          label: '低风'
			        }],
			options3: [{
			          value: 'cool',
			          label: '制冷'
			        }, {
			          value: 'fan',
			          label: '通风'
			        }, {
			          value: 'heat',
			          label: '制热'
			        }, {
			          value: 'auto',
			          label: '自动'
			        }],
			options4: [
					{
					  value: 0,
					  label: '解除锁定'
					},{
			          value: 1,
			          label: '锁定开关机',
			        }, {
			          value: 2,
			          label: '锁定模式',
			        }, {
			          value: 4,
			          label: '锁定风速',
			        }, {
			          value: 8,
			          label: '锁定温度',
			        }, {
			          value: 15,
			          label: '锁定全部'
			        }],		
            form: {
                controlType: 1,
                terminalid: '',
                powerStatus: '',             //  开关机：1
                fanSpeed: '',            //  风速：0
                workMode: '',         //  模式：0
				temperatureMode:'', //温度单位
                roomTemperatureSp: '',        //  设置温度：0
                keyBoardlock: '',          //  按键锁：0
            },
            // 参数设置校验
            rules: {},
        };
    },
    components:{
        
    },
    mounted() {
        this.form.terminalid = this.$route.params.terminalid
    },
    destroyed() {
        COUNT = 1;
        clearTimeout(Timer);
    },
    created() {
        this.getInfo(this.$route.params.terminalid)
    },

    methods: {
        // 获取表计当前读数
        async getInfo(oid) {
            COUNT++
            Service.getTerminalInfo({oid: oid}).then(data=> {
               if(data) {
                    data = data === 'success' ? [] : data;
                    this.modelData = this.fmtData(data)[0];
					this.form.temperatureMode = this.modelData.temperatureMode
                    if(COUNT>20) {
                        clearTimeout(Timer);
                        return
                    }else{
                        Timer = setTimeout(() => {
                            this.getInfo(this.$route.params.terminalid);
                        }, 5000);
                    }
                }
            })
        },
		//处理109r数据
        fmtData(data) {
            let arr = data.map(v=>{
                let obj = {}
                obj.oid = v.terminalid;
                obj.devicetype = 1;
                obj["device-model"] = v["device-model"];
                obj["device-serial"] = v["device-serial"];
                obj.status = v.status;
                obj.householdname = v.householdname;
                obj.housename = v.housename;
				if(v["device-model"] == 'FC890'){
					this.options3=[{
					          value: 'cool',
					          label: '制冷'
					        }, {
					          value: 'fan',
					          label: '通风'
					        }, {
					          value: 'heat',
					          label: '制热'
					        }]
					this.options4=[
							{
							  value: 0,
							  label: '解除锁定'
							},{
					          value: 1,
					          label: '锁定开关机',
					        }, {
					          value: 2,
					          label: '锁定模式',
					        },{
					          value: 8,
					          label: '锁定温度',
					        }, {
					          value: 15,
					          label: '锁定全部'
					        }]
					//设置温度
					if(v.data.setting_mode == "1"){
						obj.temperature = (v.data.setting_cooling_temperature)/10
					}else if(v.data.setting_mode == "8"){
						obj.temperature = (v.data.setting_heating_temperature)/10
					}else{
						obj.temperature = ""
					}
					if(v.data.setting_allow_ventilation == 0){
						obj.speed = 5
					}else if(v.data.setting_allow_ventilation == 1){
						obj.speed = 4
					}
					this.showspeed = false
					//室内温度
					obj.room_temperature=v.data.tsensor_value / 10
					//外环境传感器温度
					obj.extsensor_value=v.data.extsensor_value / 10
					//模式
					if(v.data.setting_mode == "1"){
						obj.mode = 0
					}else if(v.data.setting_mode == "4"){
						obj.mode = 1
					}else if(v.data.setting_mode == "8"){
						obj.mode = 2
					}else{
						obj.mode = 6
					}
					//模式
					if(v.data.setting_power_on == "0"){
						obj.power_on = 0
					}else if(v.data.setting_power_on == "1"){
						obj.power_on = 1
					}
					//按键锁
					if(v.data.setting_key_lock == "1"){
						obj.key_lock = 1
					}else if(v.data.setting_key_lock == "2"){
						obj.key_lock = 4
					}else if(v.data.setting_key_lock == "4"){
						obj.key_lock = 2
					}else if(v.data.setting_key_lock == "8"){
						obj.key_lock = 3
					}else if(v.data.setting_key_lock == "128"){
						obj.key_lock = 5
					}else if(v.data.setting_key_lock == "15"){
						obj.key_lock = 5
					}else if(v.data.setting_key_lock == "0"){
						obj.key_lock = 0
					}
				}
				if(v["device-model"] == 'FC810'){
					this.options3=[{
								value: 'cool',
								label: '制冷'
							}, {
								value: 'fan',
								label: '通风'
							}, {
								value: 'heat',
								label: '制热'
						}]
					//设置温度
					obj.temperature = (v.data.setting_cooling_temperature)/10

					//风速
					if(v.data.setting_speed == "128"){
						obj.speed = 0
					}else if(v.data.setting_speed == "8"){
						obj.speed = 1
					}else if(v.data.setting_speed == "4"){
						obj.speed = 2
					}else if(v.data.setting_speed == "2"){
						obj.speed = 3
					}else{
						obj.speed = 4
					}
					//室内温度
					obj.room_temperature=v.data.room_temperature
					//模式
					if(v.data.setting_mode == "1"){
						obj.mode = 0
					}else if(v.data.setting_mode == "4"){
						obj.mode = 1
					}else if(v.data.setting_mode == "8"){
						obj.mode = 2
					}else{
						obj.mode = 6
					}
					//模式
					if(v.data.setting_power_on == "0"){
						obj.power_on = 0
					}else if(v.data.setting_power_on == "1"){
						obj.power_on = 1
					}
					//设置温度
					obj.temperature = (v.data.setting_temperature)/10
					//按键锁
					if(v.data.setting_key_lock == "1"){
						obj.key_lock = 1
					}else if(v.data.setting_key_lock == "2"){
						obj.key_lock = 4
					}else if(v.data.setting_key_lock == "4"){
						obj.key_lock = 2
					}else if(v.data.setting_key_lock == "8"){
						obj.key_lock = 3
					}else if(v.data.setting_key_lock == "128"){
						obj.key_lock = 5
					}else if(v.data.setting_key_lock == "15"){
						obj.key_lock = 5
					}else if(v.data.setting_key_lock == "0"){
						obj.key_lock = 0
					}
				}
				//fc900c
				if(obj['device-model'] == 'FC900C'){
					this.options3=[{
					          value: 'cool',
					          label: '制冷'
					        }, {
					          value: 'fan',
					          label: '通风'
					        }, {
					          value: 'heat',
					          label: '制热'
					        }]
					this.showspeed = false
					//模式
					if(v.data.set_mode == "1"){
						obj.mode = 0
					}else if(v.data.set_mode == "2"){
						obj.mode = 1
					}else if(v.data.set_mode == "3"){
						obj.mode = 2
					}else{
						obj.mode = 6
					}
					//室内温度
					obj.room_temperature=v.data.temp
					//设置温度
					obj.temperature = v.data.set_temp
					//开度
					obj.twopipe_value = v.data.twopipe_value
					//模式
					if(v.data.power_on == "0"){
						obj.power_on = 0
					}else if(v.data.power_on == "1"){
						obj.power_on = 1
					}
					//按键锁
					if(v.data.key_lock == "1"){
						obj.key_lock = 1
					}else if(v.data.key_lock == "2"){
						obj.key_lock = 4
					}else if(v.data.key_lock == "4"){
						obj.key_lock = 2
					}else if(v.data.key_lock == "8"){
						obj.key_lock = 3
					}else if(v.data.key_lock == "128"){
						obj.key_lock = 5
					}else if(v.data.key_lock == "0"){
						obj.key_lock = 0
					}
					
				}
				//FC100CKM
				if(obj['device-model'] == "FC100CKM"){
					this.showlock = false
					//风速
					if(v.data.set_speed == "2"){
						obj.speed = 3
					}else if(v.data.set_speed == "4"){
						obj.speed = 2
					}else if(v.data.set_speed == "8"){
						obj.speed = 1
					}else if(v.data.set_speed == "128"){
						obj.speed = 0
					}else{
						obj.speed = 8
					}
					//模式
					if(v.data.set_mode == "1"){
						obj.mode = 0
					}else if(v.data.set_mode == "4"){
						obj.mode = 1
					}else if(v.data.set_mode == "8"){
						obj.mode = 2
					}else if(v.data.set_mode == "16"){
						obj.mode = 3
					}else{
						obj.mode = 6
					}
					//室内温度
					obj.room_temperature=v.data.temp
					//设置温度
					obj.temperature = v.data.set_temp
					//模式
					if(v.data.power_on == "0"){
						obj.power_on = 0
					}else if(v.data.power_on == "1"){
						obj.power_on = 1
					}
				}
				//FC100CKMB
				if(obj['device-model'] == "FC100CKB"){
					//风速
					if(v.data.setting_speed == "2"){
						obj.speed = 3
					}else if(v.data.setting_speed == "4"){
						obj.speed = 2
					}else if(v.data.setting_speed == "8"){
						obj.speed = 1
					}else if(v.data.setting_speed == "128"){
						obj.speed = 0
					}else{
						obj.speed = 8
					}
					//模式
					if(v.data.setting_model == "1"){
						obj.mode = 0
					}else if(v.data.setting_model == "4"){
						obj.mode = 1
					}else if(v.data.setting_model == "8"){
						obj.mode = 2
					}else if(v.data.setting_model == "16"){
						obj.mode = 3
					}else{
						obj.mode = 6
					}
					//设置温度
					obj.temperature = (v.data.setting_temp)/10
					//回风温度
					obj.temp_air = (v.data.temp_air)/10
					//回风感温器补偿
					obj.setting_calibrationailue = (v.data.setting_calibrationailue)
					//模式
					if(v.data.power_on == "0"){
						obj.power_on = 0
					}else if(v.data.power_on == "1"){
						obj.power_on = 1
					}
					//按键锁
					if(v.data.setting_key_lock == "1"){
						obj.key_lock = 1
					}else if(v.data.setting_key_lock == "2"){
						obj.key_lock = 4
					}else if(v.data.setting_key_lock == "4"){
						obj.key_lock = 2
					}else if(v.data.setting_key_lock == "8"){
						obj.key_lock = 3
					}else if(v.data.setting_key_lock == "128"){
						obj.key_lock = 5
					}else if(v.data.setting_key_lock == "15"){
						obj.key_lock = 5
					}else if(v.data.setting_key_lock == "0"){
						obj.key_lock = 0
					}
				}
				if(v["device-model"] == 'FC109R'){
					let {
						antifreezing, 
						key_lock, mode, 
						model, 
						op_at_acback, 
						power_on, 
						room_temperature, 
						speed,
						temperature, 
						temperature_dl, 
						temperature_ul,
						time_hour,
						time_minute,
						time_second,
						valve_on,
						version, } = v.data;
						obj = Object.assign(obj,{antifreezing, key_lock, mode,model,op_at_acback,power_on,room_temperature,speed,temperature,temperature_dl,temperature_ul,time_hour,time_minute,time_second,valve_on,version, } )      
                    }
					return obj
            })
            return arr
        },
        fmtValueOn(valve_on) {
            switch (valve_on) {
                case 0:
                    return "全关"
                case 1:
                    return "热水开"
                case 16:
                    return "冷水开"
                default:
                    return ''
            }
        },
        fmtSpeed(speed) {
            switch (speed) {
                case 0:
                    return "自动"
                case 1:
                    return "高风"
                case 2:
                    return "中风"
                case 3:
                    return "低风"
				case 4:
					return "允许通风"
				case 5:
					return "禁用通风"
                default:
                    return ''
            }
        },
        fmtMode(mode) {
            switch (mode) {
                case 0:
                    return "制冷"
                case 1:
                    return "通风"
                case 2:
                    return "制热"
                case 3:
                    return "自动"
                default:
                    return ''
            }
        },
        fmtOpAtAcback(op_at_acback) {
            switch (op_at_acback) {
                case 0:
                    return "保持开机"
                case 1:
                    return "恢复断电前状态"
                case 2:
                    return "强制开机"
                default:
                    return ''
            }
        },
        fmtKeyLock(key_lock) {
            switch (key_lock) {
                case 0:
                    return "解除锁定"
                case 1:
                    return "锁定开关机"
                case 2:
                    return "锁定模式"
                case 3:
                    return "锁定风速"
                case 4:
                    return "锁定温度设置"
                case 5:
                    return "锁定所有按键操作"
                default:
                    return ''
            }
        },
		fmtNewLock(key_lock) {
		    switch (key_lock) {
		        case 0:
		            return "解除锁定"
		        case 1:
		            return "锁定开关机"
		        case 2:
		            return "锁定模式"
		        case 4:
		            return "锁定风速"
		        case 8:
		            return "锁定温度设置"
		        case 15:
		            return "锁定所有按键操作"
		        default:
		            return ''
		    }
		},
        handleChangeInputair(key, val) {
            let value = this.form[key];
            if(isNaN(value) || value<-60 || value>60) {
                this.$message({
                    type: "warn",
                    message: "温度可设置范围-60-60;"
                })
                this.form[key] = "";
            }
        },
		handleChangeInput(key, val) {
		    let value = this.form[key];
		    if(isNaN(value) || value<10 || value>50) {
		        this.$message({
		            type: "warn",
		            message: "温度可设置范围10-50;"
		        })
		        this.form[key] = "";
		    }
		},
        async refresh() {
            clearTimeout(Timer);
            await this.getInfo(this.$route.params.terminalid);
            this.$message({
                message: '刷新成功',
                type: 'success'
            });
            COUNT = 1;
        },
        async onResult() {
			if(this.modelData['device-model'] == 'FC890'){
				if(this.form.workMode == 'cool'){
					this.form.cooling_temperature = true
					this.form.heating_temperature = false
				}else if(this.form.workMode == 'heat'){
					this.form.heating_temperature = true
					this.form.cooling_temperature = false
				}
			}
            let form = Object.assign({},this.form);
            let data = await Service.controlmorebytid(form);
            if(data) {
                this.$notify({
                    title: '发送成功',
                    message: '操作指令已下发，由于设备实时状态上报有延迟，请等待页面实时数据刷新。',
                    type: 'success'
                });
                COUNT = 1;
            }
        },
    }
}

</script>
<style lang='less' scoped>
.detail-box{
    margin-right: 300px;
    border-right: 1px solid #ccc;
    position: relative;
    min-height: 600px;
    .detail-subtitle{
        font-size: 16px;
        color: @font-color;
        font-weight: 400;
        margin-bottom: 10px;
    }
    .detail-item{
        border-bottom: 1px solid #ccc;
        margin: 0 20px 10px 0;
        padding: 0 0 20px 20px;
        &.noborder{
            border-bottom: none;
        }
    }
}
.control-box{
    width: 300px;
    position: absolute;
    top: 0;
    right: -300px;
    z-index: 99;
    .control-title{
        font-size: 16px;
        color: #2c3e50;
        font-weight: 400;
        margin-bottom: 10px;
        margin-left: 15px;
        overflow: hidden;
    }
}
</style>
